import { render } from "./Design_and_modelingView.vue?vue&type=template&id=4cce856d"
import script from "./Design_and_modelingView.vue?vue&type=script&lang=js"
export * from "./Design_and_modelingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__